import { Subject } from 'rxjs';

interface UpdateStudiesSubject {
    message: string;
    value?: boolean;
    studyId?: string;
    isDeferred?: boolean;
}

const warningLostDataSubject = new Subject<boolean>();
const updateStudiesSubject = new Subject<UpdateStudiesSubject>();
const viewRiskDetailsSubject = new Subject<undefined>();
const viewLegacySiteDashboardSubject = new Subject<undefined>();

const slideBarStatusSubject = new Subject<boolean>();
const legacyWarningLostDataSubject = new Subject<boolean>();
const reflowChartSubject = new Subject<undefined>();
let SlideBarStatus = false;

const NavigationService = {
    showWarningLostDataModal: (message: boolean) => {
        warningLostDataSubject.next(message);
    },
    onShowWarningLostDataModal() {
        return warningLostDataSubject.asObservable();
    },
    setUpdateStudies: (message: string, value?: boolean, studyId?: string, isDeferred?: boolean) => {
        updateStudiesSubject.next({
            message,
            value,
            studyId,
            isDeferred,
        });
    },
    onUpdateStudies() {
        return updateStudiesSubject.asObservable();
    },

    // This is not currently set because the old RAM code was deleted
    // However, when we build the new screens, if we have a button to view risk details in the risk log, as per old functionality
    // Then we can use this again, and set it when we navigate the risk log page.
    // The onViewRiskDetails is used in pagenav, and ensures the pagenav updates correctly
    setViewRiskDetails: () => {
        viewRiskDetailsSubject.next(undefined);
    },
    onViewRiskDetails() {
        return viewRiskDetailsSubject.asObservable();
    },

    // LEGACY METHODS
    setViewLegacySiteDashboard: () => {
        viewLegacySiteDashboardSubject.next(undefined);
    },
    onViewLegacySiteDashboard() {
        return viewLegacySiteDashboardSubject.asObservable();
    },
    // Sets state of the detail row on old grids based on whether the pagenav (formerly sidebar) is open or closed
    // e.g., Risk Assessment > Risks > expand child row for a risk
    getSlideBarStatus: (): boolean => SlideBarStatus,
    setSlideBarStatus: (status: boolean) => {
        SlideBarStatus = status;
        slideBarStatusSubject.next(SlideBarStatus);
    },
    onUpdateSideBar() {
        return slideBarStatusSubject.asObservable();
    },
    legacyShowWarningLostDataModal: (message: boolean) => {
        legacyWarningLostDataSubject.next(message);
    },
    legacyOnShowWarningLostDataModal() {
        return legacyWarningLostDataSubject.asObservable();
    },
    legacySetReflowChart: () => {
        reflowChartSubject.next(undefined);
    },
    legacyOnReflowChart: () => reflowChartSubject.asObservable(),
};

export default NavigationService;
